// extracted by mini-css-extract-plugin
export default {"container":"index__container--bk3oJ","loading-shimmer":"index__loading-shimmer--ymsFu","loadingShimmer":"index__loading-shimmer--ymsFu"};